/**
 * E-BUNDLE-16 — die Positionsrechnung des Account-Menues liegt getrennt vom
 * Menue selbst. Der Avatar-Knopf braucht sie, sobald das Menue aufgeht; der
 * schwere Menueinhalt kommt erst danach. Dasselbe Muster wie
 * `popoverDeepLinkStyle.ts` aus E-BUNDLE-15.
 */
export interface MenuPosition {
  readonly top: number;
  readonly left: number;
  readonly maxInlineSize: number;
}

export function computeMenuPosition(
  triggerRect: { top: number; bottom: number; left: number; right: number },
  viewport: { width: number; height: number },
  preferredInlineSize = 280,
): MenuPosition {
  // GT-APP-SHELL-2-POST-DEPLOY-VISUAL-POLISH-01 (DL-123) — the owner reported the
  // popover hugging the right viewport edge. A slightly larger gutter gives the
  // menu breathing room from the chrome on every side (it is already viewport-
  // aware: clamps horizontally and flips above the trigger when it would overflow
  // the bottom).
  const GUTTER = 12;
  const VERTICAL_GAP = 6;
  const maxInlineSize = Math.max(160, Math.min(preferredInlineSize, viewport.width - GUTTER * 2));
  let left = triggerRect.right - maxInlineSize;
  if (left < GUTTER) left = GUTTER;
  if (left + maxInlineSize > viewport.width - GUTTER) {
    left = Math.max(GUTTER, viewport.width - maxInlineSize - GUTTER);
  }
  let top = triggerRect.bottom + VERTICAL_GAP;
  const ESTIMATED_HEIGHT = 320;
  if (
    top + ESTIMATED_HEIGHT > viewport.height - GUTTER &&
    triggerRect.top - VERTICAL_GAP - ESTIMATED_HEIGHT > GUTTER
  ) {
    top = triggerRect.top - VERTICAL_GAP - ESTIMATED_HEIGHT;
  }
  if (top < GUTTER) top = GUTTER;
  return { top, left, maxInlineSize };
}
